/** Stable KLine instance id for the custom-indicator editor preview chart. */
export function editorPreviewInstanceId(projectId: string): string {
  return `editor_preview_${projectId}`;
}

export function editorPreviewIndicatorId(projectId: string): string {
  return `custom_${projectId}`;
}

const EDITOR_PREVIEW_PREFIX = "editor_preview_";

export function isEditorPreviewInstanceId(instanceId: string): boolean {
  return instanceId.startsWith(EDITOR_PREVIEW_PREFIX);
}
